'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { ProgressRootContext } from './context/progress-root.context';
import { progressTrackRecipe } from './styles/progress-track.styles';
import type { ProgressTrackPropsInterface } from './types/progress-track.types';

/**
 * The progress bar's full track
 *
 * @related ['ProgressBar']
 * @since 10.0.0
 */
export const ProgressTrack = forwardRef<HTMLDivElement, ProgressTrackPropsInterface>(
  (props: ProgressTrackPropsInterface, forwardedRef) => {
    const context = useContext(ProgressRootContext);

    const { className, css: cssProp, size = context.size || 'sm', ...rest } = props;

    const styles = css(progressTrackRecipe.raw({ size }), cssProp);

    return (
      <div
        className={cx('c11n', 'c11n_progress__track', styles, className)}
        data-c11n-component="Progress.Track"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      />
    );
  },
);

ProgressTrack.displayName = 'Progress.Track';
